import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.CHAT_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.local.setItem(types.CHAT_PAGE_SIZE, pageSize)
  },
  [types.SET_PREV](state, prev) {
    state.prev = prev
    storage.local.setItem(types.SET_PREV, prev)
  },
  [types.SET_NEXT](state, next) {
    state.next = next
    storage.local.setItem(types.SET_NEXT, next)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.CHAT_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.CHAT_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.CHAT_FILTER_BY, filterBy)
  },
  [types.SET_CHECKED](state, data) {
    if (data.url === 'all') {
      state.channels.forEach(element => {
        element.isChecked = data.isChecked
      })
    } else {
      let found = state.channels.find(x => x.channel_url === data.url)
      if (found) {
        found.isChecked = data.isChecked
      }
    }
    state.isChecked = false
    state.isAllChecked = false
    let filtered = state.channels.filter(x => x.isChecked === true)
    if (filtered.length > 0) {
      state.isChecked = true
      if (filtered.length === state.channels.length) {
        state.isAllChecked = true
      }
    }
    console.log('Channels Checked', filtered)
  },
  [types.RESET_CHANNELS](state) {
    state.isChecked = false
    state.more = ''
    state.channels = []
  },
  [types.RESET_MESSAGES](state) {
    state.messages = []
  },
  [types.RESET_USERS](state) {
    state.moreUsers = ''
    state.users = []
  },
  [types.RESET_FOUND_MEMBERS](state) {
    state.foundMembers = []
  },
  [types.SET_FOUND_MEMBERS](state, data) {
    state.foundMembers = []
    if (data) {
      if (Array.isArray(data)) {
        state.foundMembers = data
      }
      // data.forEach(element => {
      //   if (element.nickname.trim() !== '') {
      //     if (Object.keys(element.metadata).length > 0) {
      //       state.foundMembers.push({
      //         label: element.label,
      //         guid: element.user_id,
      //         user: element.metadata.user,
      //         fileAs: element.nickname,
      //         email: element.metadata.email,
      //         name: element.nickname,
      //         status: '',
      //         isActive: element.is_active
      //       })
      //     }
      //   }
      // })
    }
    console.log('Found Members', state.foundMembers)
  },
  [types.SET_NEW_MEMBERS](state, data) {
    console.log('Before Set New Members', {
      newMembers: data,
      channels: state.channels,
      currentChannel: state.currentChannel
    })
    let added = []
    data.forEach(element => {
      let found = state.currentChannel.members.find(x => x.user_id === element.guid)
      if (!found) {
        added.push(element)
      }
    })
    added.forEach(element => {
      state.currentChannel.members.push({
        is_active: true,
        is_muted: false,
        is_online: false,
        last_seen_at: -1,
        metadata: {
          email: element.email,
          firm: '',
          user: element.user,
          role: ''
        },
        muted_description: '',
        muted_end_at: -1,
        nickname: element.name,
        profile_url: '',
        require_auth_for_profile_image: false,
        role: '',
        state: 'joined',
        user_id: element.guid
      })
    })
    state.removedMembers = []
    state.currentChannel.members.forEach(element => {
      let found = data.find(x => x.guid === element.user_id)
      if (!found) {
        state.removedMembers.push(element.user_id)
      }
    })
    state.removedMembers.forEach(guid => {
      state.currentChannel.members = state.currentChannel.members.filter(x => x.user_id !== guid)
    })
    let channel = state.channels.find(x => x.channel_url === state.currentChannel.channel_url)
    if (channel) {
      channel.members = state.currentChannel.members
    }
    console.log('After Set New Members', {
      newMembers: data,
      channels: state.channels,
      currentChannel: state.currentChannel
    })
  },
  [types.SET_CHANNELS](state, data) {
    state.isChecked = false
    if (data) {
      if (data !== 'Not Found') {
        state.more = data.next ? data.next : ''
        state.channels = state.channels.concat(data.channels)
        state.channels.forEach(element => {
          element.isChecked = false
        })
      }
    }
    console.log('Chat Admin: Got Channels', state.channels)
  },
  [types.SET_CURRENT_CHANNEL](state, data) {
    state.currentChannel = data
  },
  [types.SET_CHANNEL](state, data) {
    state.channel = data
    console.log('Chat Admin: Got Channel', state.channel)
  },
  [types.SET_CHANNEL_METADATA](state, data) {
    if (state.channel) {
      state.channel.metadata = data
      console.log('Chat Admin: Got Channel Metadata', state.channel)
    }
  },
  [types.SET_MESSAGES](state, data) {
    state.messages = data
    console.log('Chat Admin: Got Channel Messages', state.channels)
  },
  [types.SET_REPORT](state, data) {
    state.report = data
    console.log('Got Report', state.report)
  },
  [types.SET_USER_CHANNEL_COUNT](state, data) {
    state.userChannelCount = 0
    if (data) {
      state.userChannelCount = data.group_channel_count
    }
    console.log('Got User Channel Count', state.userChannelCount)
  },
  [types.SET_USER_CHANNELS](state, data) {},
  [types.SET_USERS](state, data) {
    state.isChecked = false
    if (data) {
      state.moreUsers = data.next ? data.next : ''
      state.users = state.users.concat(data.users)
      state.users.forEach(element => {
        element.isChecked = false
      })
    }
    console.log('Got Users', state.users)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/mutations.js